<template> 
    <div class="controls">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
        </head>  
        <button class="button" v-if="!deviceCharacteristic"
                :class="{'is-warning': !deviceCharacteristic, 'is-success' : deviceCharacteristic }" 
                :disabled="deviceCharacteristic"
                id="pair" v-on:click="connect">Connect device</button>
        <div v-if="deviceCharacteristic">

            <div class="control">
                <label class="radio">
                    <input type="radio" value="exactLight" v-model="mode">
                    Exact Light
                </label>
                <label class="radio">
                    <input type="radio" value="lightCoefficient" v-model="mode">
                    Light Coefficient
                </label>
            </div>    

            <div class="filed">
                <label class="label">Light calibration coefficient</label>
                <div class="control">
                    <input class="input" type="text" v-model="xLight" placeholder="1.0000" :disabled="mode!='lightCoefficient'" > 
                </div>
            </div>

            <div class="filed">
                <label class="label">Set Light</label>
                <div class="control">
                    <input class="input" type="text" v-model="setLight" placeholder="1000" :disabled="mode!='exactLight'" > 
                </div>
            </div>

            <div class="filed">
                <label class="label">Light sensor temperature coefficient, %/C</label>
                <div class="control">
                    <input class="input" type="text" v-model="varCtIsc" placeholder="0.04" :disabled="true" >  
                </div>
            </div>
            
            <div class="filed">
                <label class="label">Panel temperature, C</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="avarageTemperature"
                        :disabled="true" 
                        placeholder="temperature">  
                </div>
            </div>

            <div class="filed">
                <label class="label">Average light, W/m2</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="avarageLight"
                        :disabled="true" 
                        placeholder="light">
                </div>
            </div>

           <div class="filed">
                <label class="label">Tester temperature, C</label>
                <div class="control">
                     <input class="input" type="input"
                        :class="{'is-danger' : overheat, 'is-warning' : heatsinkTemperature > 45}"
                        v-model="heatsinkTemperature"
                        :disabled="true" 
                        placeholder="tester temperature">  
                </div>
            </div>   

            <div class="filed">
                <label class="label">Current calibration coefficient</label>
                <div class="control">
                    <input class="input" type="text" v-model="xI" placeholder="1.0000"> 
                </div>
            </div>

            <br>

            <div class="columns">                       
                <button class="column button is-danger"
                    v-if="!sendLocked" 
                    id="calibrateButton" 
                    :disabled="sendLocked"
                    v-on:click="setLightCalibration">Set Light Calibration</button>

                <button class="column button is-info"
                    v-if="!sendLocked" 
                    id="calibrateButton" 
                    :disabled="sendLocked"
                    v-on:click="getCalibration">Get Calibration</button> 
                
                <button class="column button is-danger"
                    v-if="!sendLocked"                 
                    :disabled="sendLocked"
                    v-on:click="setCurrentCalibration">Set Current Calibration</button>

            </div>

            <div v-if="error" class="notification  is-warning">{{error}}</div>

            <figure class="image is-128x128" v-if="deviceCharacteristic && sendLocked">
                <img src="..\assets\spinner.gif">
            </figure>
        </div>
    </div>
</template>
<script>
import { setLightCalibrationCommand, setLightCalibrationCommandEnd, getCalibrationCommand, setCurrentCalibrationCommand, setCurrentCalibrationCommandEnd } from '../shared/config';
import { parser } from '../shared/parser';
export default {
    name: "Calibration",
    async created () {
        if(!this.$store.state.accessToken){
            this.$router.push('login');
            return;            
        }
    },
    data() {
        return {
            
            //sampleTemperature: undefined,
            serviceUUID : "0000ffe0-0000-1000-8000-00805f9b34fb",
            characteristicId : "0000ffe1-0000-1000-8000-00805f9b34fb",
            deviceCharacteristic : null,
            endChar : '&',   
            message: '',  
            locked: false,
            
            avarageLight: undefined,
            avarageTemperature: undefined,
            heatsinkTemperature: undefined,

            overheat : false,
            tHeatsinkMax : 50,

            xLight: undefined,
            varCtIsc: undefined,
            setLight: undefined,
            xI : undefined,

            mode: 'exactLight',
            error: undefined,
        }
    },
    mounted () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            // const button = document.getElementById('pair');
            // button.addEventListener('pointerup', function () {
                // this.connect();
            // });
        })
    },
    computed: {
        sendLocked() {
            return this.locked || !this.deviceCharacteristic;
        },
    },
    methods: {        
        async onNewMessage(msg) {
            

/* eslint-disable no-debugger */
//debugger;
/* eslint-enable no-debugger */

            if (!msg)
                return;
            const index = msg.indexOf(this.endChar);
            if (index >= 0) {
                let newMsg = msg.substring(0, index);
                this.message += newMsg;
                if (index === msg.length - 1) {
                    msg = "";
                }
                else {
                    msg = msg.substring(index + 1, msg.length);
                }
                // TODO: handle message
                console.log(this.message);
                const sensorMessageStart = "Sns;";  
                const calibrationResult = "Cal;";  
                const commandError = "er:";  
                
                if(parser.stringContains(this.message,sensorMessageStart))
                {
                    const sensors = parser.readSensorsMessage(this.message);          
                    this.avarageLight = sensors.light;
                    this.avarageTemperature = sensors.tModule;
                    this.heatsinkTemperature = sensors.tHeatsink;  
                    this.overheat =  sensors.tHeatsink > this.tHeatsinkMax;                       
                }
                else if(parser.stringContains(this.message,calibrationResult))
                {
                    const calibration = this.readCalibration(this.message);
                    this.xLight = calibration.xIsc;
                    this.varCtIsc = calibration.CtIsc
                    this.xI = calibration.xI;

                    this.error = undefined;
                    this.locked = false;
                }
                 else if(parser.stringContains(this.message,commandError))
                {

                    this.error = this.message;
                    this.locked = false;
                }

                
                this.message = "";
                if (msg) {
                    await this.onNewMessage(msg);
                }
            }
            else {
                this.message += msg;
            }

        },
        
        async handleCharacteristicValueChanged(event) {
            const value = event.target.value;
            const length = value.byteLength;
            if (length <= 0)
                return;
            let msg = String.fromCharCode([value.getUint8(0)]);

            for (var i = 1; i < length; i++) {
                msg += String.fromCharCode([value.getUint8(i)]);
            }
            await this.onNewMessage(msg);
            //console.log('Received ' + msg);
        },

        onTesterDisconnected(){
            console.log("on tester disconected");
            this.$data.deviceCharacteristic = null;            
        },

        async connect(){
            document.addEventListener('onTesterDisconnected',this.onTesterDisconnected);

            navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: [this.serviceUUID]
            })
            .then(device => {
                // Human-readable name of the device.
                console.log(device.name);
                device.ongattserverdisconnected = function () {                                        
                    console.log("Tester disconnected");
                    document.dispatchEvent(new CustomEvent('onTesterDisconnected', {}));
                };
                // Attempts to connect to remote GATT Server.
                return device.gatt.connect();
            })
            .then(server => {
                //console.log(server);
                return server.getPrimaryService(this.serviceUUID);
            })
            .then(service => {
                console.log(service);
                //return service.getCharacteristic
                return service.getCharacteristic(this.characteristicId);
            })
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
                characteristic.addEventListener('characteristicvaluechanged',
                    this.handleCharacteristicValueChanged);
                console.log('Notifications have been started.');
                this.deviceCharacteristic = characteristic;
            })
            .catch(error => {
                console.log(error);
                this.deviceCharacteristic = null;
            });
        },

        getCalibration(){
             if (this.deviceCharacteristic == null) {
                console.log('writer is null');
            }
            else {
                this.locked = true;
                console.log('get calibration');
                var value = Uint8Array.of(getCalibrationCommand);
                this.deviceCharacteristic.writeValue(value);                                
            }
        },

        prepareCalibrationCommand(startCommand, lightCoefficient, endCommand)
        {
            const buffer = new ArrayBuffer(4);
            const farr = new Float32Array(buffer);
            farr[0] = lightCoefficient;
            const uints = new Uint8Array(farr.buffer);

            //yourNumber.toString(16)
            //farr. = lightCoefficient;
            const value = Uint8Array.of(startCommand, ...uints, endCommand);   
            return value;         
        },

        calculateLightCoefficient()
        {
            if(this.mode == 'lightCoefficient')
                return this.xLight;

            if(this.mode == 'exactLight')
            {
                const x1 = this.xLight;
                const y1 = this.avarageLight;
                const y2 = this.setLight;
                const x2 = x1 * y2 / y1;
                return x2;
            }
        },
        
        setLightCalibration(){   
            var lightCoefficient = this.calculateLightCoefficient();
            var command = this.prepareCalibrationCommand(setLightCalibrationCommand, lightCoefficient, setLightCalibrationCommandEnd);
            this.setCalibration(command);
        },

        setCurrentCalibration(){
            if(!this.xI)
            {
                alert("Please click get callibration first.");
                return;                
            }
            var command = this.prepareCalibrationCommand(setCurrentCalibrationCommand, this.xI, setCurrentCalibrationCommandEnd);
            this.setCalibration(command);    
        },

        setCalibration(commandsWithValue){
            if(! confirm("Are you sure to set a new calibration?"))
                return; 

             if (this.deviceCharacteristic == null) {
                console.log('device is not ready');
                this.error = 'device is not ready';
            }
            else {
                this.locked = true;
                console.log('set calibration ...');
               
                //var value = Uint8Array.of(63, x, 65);
                this.deviceCharacteristic.writeValue(commandsWithValue);  
                this.error = undefined;                              
            }

        },  

        readCalibration(msg){
            const parts = msg.split(";");
            const result = 
            {
                xIsc : parser.getHeaderPartFloat(parts,"xIsc="),
                CtIsc : parser.getHeaderPartFloat(parts,"CtIsc="),
                xI : parser.getHeaderPartFloat(parts,"xI="),                
            };
            return result;
        },       

    },    
    
}
</script>
